import * as React from "react";

import JSONTree from 'react-json-tree';

export interface JsonViewerProps {
	data: string
}

export default class JsonViewer extends React.Component<JsonViewerProps, any> {
    constructor() {
        super();
	}
	
	render() {
		 var data = JSON.parse(this.props.data);
		 
         return (
             <div className="json-viewer">
                <div className="row panel panel-default json-tree">
                     <JSONTree data={data} invertTheme={true} />
                </div>
                    <pre>{JSON.stringify(data, undefined, 4)}</pre>
            </div>
         );
	 }
}


// WEBPACK FOOTER //
// ./Scripts/components/JsonViewer.tsx